export default __webpack_public_path__ + "static/media/roof.8524e83a.jpg";